import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import registerServiceWorker from '@/registerServiceWorker';
import router from './router';
import store from './store';
import mixin from './mixin';
import i18n from './config/i18n';
import {dateFilter, dateFilter2, logFilter, mediaUrl} from '@/config/filter';
import App from './App.vue';
import VueYouTubeEmbed from 'vue-youtube-embed';
Vue.use(VueYouTubeEmbed);
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
const lodashOptions = { name: 'custom', lodash: lodash };
Vue.use(VueLodash, lodashOptions);
import VueMoment from 'vue-moment';
Vue.use(VueMoment);
import TextareaAutosize from 'vue-textarea-autosize';
Vue.use(TextareaAutosize);
// filter
Vue.filter('date', dateFilter);
Vue.filter('date2', dateFilter2);
Vue.filter('log', logFilter);
Vue.filter('mediaUrl', mediaUrl);

// bootstrap
Vue.use(BootstrapVue);

Vue.mixin(mixin);

registerServiceWorker();
import 'jquery';
import 'jquery-ui';
import 'jquery-ui/themes/base/datepicker.css';
import 'jquery-ui/themes/base/slider.css';
import 'jquery-ui/themes/base/theme.css';

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#vue-app');
